// © 2026 AttainIP Engineering
import { Fragment } from 'react';

/**
 * Renders an audit event's full payload (correlation_id, idempotency_key,
 * actor/resource fields, and all metadata) as a label-value grid.
 */
export function AuditEventDetail({ evt }: { evt: any }) {
  const meta = evt.metadata || {};
  const ordered: Array<[string, any]> = ([
    ['correlation_id', evt.correlation_id],
    ['idempotency_key', evt.idempotency_key],
    ['actor_id', evt.actor_id],
    ['actor_ip', evt.actor_ip],
    ['resource_type', evt.resource_type],
    ['resource_id', evt.resource_id],
    ...Object.entries(meta),
  ] as Array<[string, any]>).filter(([, v]) => v !== null && v !== undefined && v !== '');

  return (
    <div className="grid grid-cols-[160px_1fr] gap-x-4 gap-y-1 text-xs font-mono">
      {ordered.map(([k, v]) => (
        <Fragment key={k}>
          <div className="text-gray-500">{k}</div>
          <div className="text-gray-800 break-all whitespace-pre-wrap">
            {typeof v === 'object' ? JSON.stringify(v, null, 2) : String(v)}
          </div>
        </Fragment>
      ))}
    </div>
  );
}
